import { faInfoCircle, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from '../../styles/ocorrencia/ConsultarOcorrenciaForm.module.scss'
import clsx from 'clsx'
import { hasPermission } from '../../services/utils'
import { PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO, PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA, PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL } from '../../utils/constants'

type Props = {
  onInfoClick: (ocorrencia: Record<string, unknown>) => () => void
  onMapCenter: (ocorrencia: Record<string, unknown>) => () => void
  dataItem: Record<string, unknown>
}

export const ResultadoProcessoCommandGridCell = ({
  onInfoClick,
  onMapCenter,
  dataItem,
}: Props) => {
  return (
    <td className="k-command-cell">
      <div className={'gridCommand'}>
        {dataItem.hasGeom ? 
        <div
          role="button"
          onClick={onMapCenter(dataItem)}
          className={clsx(styles.gridCommandIconButton, 'espacoGridAction')}
        >
          <FontAwesomeIcon icon={faLocationDot} title="Mostrar no Mapa" />
        </div>
        : <div className='espacoGridAction'>&nbsp;</div>}
        {hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)
        ?
        
        <div
          role="button"
          className={styles.gridCommandIconButton}
          onClick={onInfoClick(dataItem)}
        >
          <FontAwesomeIcon icon={faInfoCircle} title="Detalhes de registo" />
        </div>
        : ''}
      </div>
    </td>
  )
}
